import { render, staticRenderFns } from "./FieldSetForm.vue?vue&type=template&id=869f6d7e&lang=pug"
import script from "./FieldSetForm.vue?vue&type=script&lang=js"
export * from "./FieldSetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports